import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { downloadFile } from '../../../utils/util';
import { Breadcrumbs } from '../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../utils/constants';
import PackListService from '../../../services/PackListService';

const ListOrderItem = (props) => {
    const order = props.location.state.order;
    const orderItems = order?.items || [];
    

    return (
        <div>
            <Breadcrumbs id="listOrderItem" title={{ icon: "mdi mdi-clipboard-list-outline", label: `${order?.orderCode} - ${order?.supplierCode}` }} />
            <div   style={{ paddingBottom: '10px' }}>
                {order.packListId === null ||
                        (order.packList.status === ENUMS.ePackListStatus.ReprovedFinance.value
                            || order.packList.status === ENUMS.ePackListStatus.ReprovedPatrimonial.value
                        ) ?

                        <div
                            className="title sixth-text-color right"
                            style={{  paddingRight: '10px'}}
                        ><i onClick={(event) => {
                            event.preventDefault();
                            let packList = { orderId: order.orderId };
                            props.createPackList(packList, () => { props.history.go(-1);});
                            

                        }}
                            className={`mdi mdi-36px mdi-call-made green-text`} />
                        </div> : null
                    }
                    {order.packListId != null &&
                        (order.packList.status === ENUMS.ePackListStatus.PendingFinance.value
                            || order.packList.status === ENUMS.ePackListStatus.PropertyPending.value
                        ) ?
                        <div>
                            <div
                                className="title sixth-text-color right"
                                style={{  paddingRight: '10px'}}
                            ><i onClick={(event) => {
                                event.preventDefault();
                                let packList = { id: order.packListId };
                                props.reprove(packList, () => { props.history.go(-1);});
                             

                            }}
                                className={`mdi mdi-36px mdi-alpha-x-circle-outline red-text`} />
                            </div>
                            <div
                                className="title sixth-text-color right"
                            ><i onClick={(event) => {
                                event.preventDefault();
                                let packList = { id: order.packListId };
                                props.approve(packList,() => { props.history.go(-1);});


                            }}
                                className={`mdi mdi-36px mdi-checkbox-marked-circle-outline green-text`} />
                            </div>
                  
                        </div> : null
                    }
                    {order.packListId != null && order.packList.status === ENUMS.ePackListStatus.PackListAuthorized.value
                    &&
                    <span
                        className="title sixth-text-color right"
                        style={{  paddingRight: '10px'}}
                    ><i onClick={(event) => {
                        event.preventDefault();
                        event.preventDefault();
                        let packList = { id: order.packListId };
                        props.reportPdf(packList, (data) => {
                            downloadFile(data, `romaneio${order.packListId}.pdf`, "data:application/pdf", true);
                        });
                    }}
                        className={`mdi mdi-36px mdi-printer`} />
                    </span>
                }
            </div>
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                {
                    orderItems.map((item, index) => {
                        return (
                            <div key={`${item.orderItemId} - ${index}`} className="row" style={{ marginBottom: '0px' }}>
                                <li
                                    key={item.orderItemId}
                                    className="collection-item avatar z-depth-1"
                                    style={{ backgroundColor: 'white', color: 'black', minHeight: '120px', display: 'block' }}>

                                    <div className="input-field col s12">
                                        <strong><span className="title sixth-text-color">{`${item.partnumber}`}</span></strong>
                                        <br />
                                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{`${item.description}`}</span>
                                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{`${item.quantity}`}</span>
                                    </div>
                                </li>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}
const mapStateToProps = () => {
    return {
       
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        createPackList: (packList, callback) => {
            dispatch(PackListService.createPackList(packList, callback));
        },
        approve: (packList, callback) => {
            dispatch(PackListService.approve(packList, callback));
        },
        reprove: (packList, callback) => {
            dispatch(PackListService.reprove(packList, callback));
        },
        report: (filter, callback) => {
            dispatch(PackListService.report(filter, callback));
        },
        reportPdf: (filter, callback) => {
            dispatch(PackListService.reportPdf(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ListOrderItem)));
